import React, {FC} from "react";
import Player from "../common/player";

import styles from "./fixtureEditor.module.scss";
import {FixtureFiles as FixtureFilesType} from "../../utils/hooks/useFixtureFootage";

export interface FixtureEditorProps {
    onCancel?: () => void;
    onSave?: () => void;
    files: FixtureFilesType[];
}

const FixtureEditor: FC<FixtureEditorProps> = ({ onCancel, onSave, files}) => {
    return (
        <div className={styles.parentContainer}>
            <div className={styles.childContainer}>
                <div className={styles.editorContainer}>
                    <Player id={"player"} onCancel={onCancel} onSave={onSave}
                            displayExtraTrimControls={true} files={files}>
                    </Player>
                </div>
            </div>
        </div>
    );
};

export default FixtureEditor;
